import React from "react";

type SelectIconProps = {
  label: string;
  iconSrc: string | null;
  iconAlt: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
};

const SelectIcon = ({
  label,
  iconSrc,
  iconAlt = "",
  onClick,
  className = "",
}: SelectIconProps) => {
  return (
    <button
      onClick={onClick}
      className={[
        "flex flex-col items-center justify-center gap-4",
        "max-w-75 w-full p-4 max-h-32.5",
        "cursor-pointer rounded-[10px]",
        "bg-primary text-white hover:bg-[#000B54]",
        "text-[16px] font-bold transition-colors leading-snug",
        className,
      ].join(" ")}
    >
      <span>{label}</span>

      {iconSrc && (
        <img
          src={iconSrc}
          alt={iconAlt || label}
          className="w-15 h-15 object-contain"
        />
      )}
    </button>
  );
};

export default SelectIcon;
